import React from "react";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";

import {Title, Mt3, Mt4, Text} from "@/components/typography/index.jsx";
import Icon from '@svg/casper-144.svg';


export default function ErrorNotification({children = 'Please try refreshing the page and try again.', ...props}) {
    return (
        <Container>
            <div>
                <IconContainer>
                    <Icon/>
                </IconContainer>
                <Mt4>
                    <NotificationTitle>Something went wrong.</NotificationTitle>
                </Mt4>
                <Mt3>
                    <Notification dangerouslySetInnerHTML={{ __html: children }}/>
                </Mt3>
            </div>
        </Container>
);
}

ErrorNotification.propTypes = {
    children: PropTypes.string,
};

const Container = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '25px',
    minWidth: '380px',

    '@media (max-width: 500px)': {
        minWidth: 'auto',
        minHeight: 'auto',
    },
});

const IconContainer = styled('div')({
    justifyContent: 'center',
    display: 'flex',
});

const NotificationTitle = styled(Title)({
    textAlign: 'center',
});

const Notification = styled(Text)({
    textAlign: 'center',
});
